// extracted by mini-css-extract-plugin
module.exports = {"badgeAds":"BadgeAds-module__badgeAds___3SUFw","badgeAd":"BadgeAds-module__badgeAd___JnhfS"};